exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".horizontal-center {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%); }\n", ""]);

